import {REHYDRATE} from 'redux-persist'
import types from "./types";

const initialState = {
  loaded: false,
  currentExtent: null,
  perimeterIncident: null,
  showAddIrwinIdToPerimeter: false
};

const mapReducer = (state = initialState, action) => {
  switch (action.type) {
    case REHYDRATE:
      const extent = action.payload && action.payload.map && action.payload.map.currentExtent ?
        action.payload.map.currentExtent
        : null;
      if(extent){
        return {
          loaded: false,
          currentExtent: extent
        };
      }
      return state;

      case types.REHYDRATE:
        const mapExtent = action.payload && action.payload.map && action.payload.map.currentExtent ?
          action.payload.map.currentExtent
          : null;
        if(mapExtent){
          return {
            loaded: false,
            currentExtent: mapExtent
          };
        }
        return state;
    case types.SET_EXTENT:
      return {
        ...state,
        currentExtent: action.payload.extent
      }
    case types.IRWIN_ID_PERIMETER:
        return {
          ...state,
          perimeterIncident: action.payload.perimeterIncident,
          showAddIrwinIdToPerimeter: (action.payload.perimeterIncident !== null)
    }
    case types.MAP_LOADED:
      return {
        ...state,
        loaded: true
      }


    default:
      return state;
  }
}

export default mapReducer;
